export const commonSettings = {
    dataServer: "/api",
    //dataServer: "/api",
    webServer: "https://app.elgra2027.org",
    graphqlServer: "/graphql",
    matrixServer: "https://app.elgra2027.org",
    matrixServerName: "localhost",
};